import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { FuseAlertComponent, FuseAlertModule } from "@fuse/components/alert";
import { TranslocoCoreModule } from "app/core/transloco/transloco.module";
import { SharedModule } from "app/shared/shared.module";
import { AppVersionUpdateComponent } from './app-version-update.component';

@NgModule({
    declarations: [
        AppVersionUpdateComponent
    ],
    imports     : [
        MatButtonModule,
        TranslocoCoreModule,
        FuseAlertModule,
        CommonModule,
        SharedModule
    ],
    exports     : [
        AppVersionUpdateComponent
    ]
})
export class AppVersionUpdateModule
{
}